;(function() {
    const ajaxCRUD = CommentsLsAjaxCRUD();
    const ToggleVisible = CommentsLSToggleVisible();

    function isDisabledSubmit(fieldsRequired) {
        let result = false;

        for (let i = 0; i < fieldsRequired.length; i++) {
            if ($(fieldsRequired[i]).val() === "") {
                result = true;
            }
        }

        return result;
    }

    const commentBody = $(".comments"),
        form = commentBody.find("form"),
        fieldsAll = commentBody.find("input, textarea"),
        fieldName = commentBody.find("#new-comment-name"),
        fieldMessage = commentBody.find("#new-comment-message"),
        fieldEmail = commentBody.find("#new-comment-email"),
        buttonSubmit = commentBody.find("button[type=submit]");

    fieldMessage.on("input", function(event) {
        ToggleVisible.fields(event.target.value, [fieldName, fieldEmail]);
    });

    fieldsAll.on("input", function () {
        if (isDisabledSubmit([fieldName, fieldMessage])) {
            buttonSubmit.prop("disabled", true);
        } else {
            buttonSubmit.prop("disabled", false);
        }
    });

    form.on("submit", function (event) {
        event.preventDefault();
        ajaxCRUD.create(form);
    });
}());
